import gql from "graphql-tag";

export default gql`
  query BrazilianIssuerDividends(
    $tickerSymbol: TickerSymbol!
    $securityCountry: SecurityCountry!
    $filterByExcludingFrom: Int
    $filterByExcludingTo: Int
  ) {
    dividendsPaid(
      tickerSymbol: $tickerSymbol
      country: $securityCountry
      filterByExcludingFrom: $filterByExcludingFrom
      filterByExcludingTo: $filterByExcludingTo
    ) {
      nodes {
        tickerSymbol
        excludingDate
        recordDate
        dividendType
        distributionFrequency
        payDate
        amountPaid
      }
      availableYears
      dividendsPaidByYear {
        fiscalYear
        tickerSymbol
        amountPaid
      }
      dividendYieldByTickerSymbol {
        tickerSymbol
        dividendYield
        amountPaid
      }
    }

    stockDividendsPaid(tickerSymbol: $tickerSymbol, country: $securityCountry) {
      tickerSymbol
      excludingDate
      sharePaid
    }
  }
`;
